import { PortfolioApi } from '@/api'
import { configuration } from '@/lib/api'

export const portfolioApi = new PortfolioApi(configuration)
